var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-collapse',{staticClass:"mt-1",model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }